import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives, isRef as _isRef, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ff5d2dee"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "order-search flex-col" }
const _hoisted_2 = { class: "order-search-title" }
const _hoisted_3 = { class: "order-search flex-col" }
const _hoisted_4 = { class: "order-search-title" }

import NewInputBatchSearch from '@/components/NewInputBatchSearch/index.vue'
import { t } from '@/plugins/i18n'
import { ref, reactive, toRaw, watch, computed, onMounted } from 'vue'
import { cloneDeep } from 'lodash'
import { Search } from '@element-plus/icons-vue'
import AppLink from '@/components/common/AppLink.vue'
import store, { isD2C, useRtfix, getCustomerShopPlatform, isMultiStore, isJA } from '@/store'
import dblclick from '@/components/BatchSearch/index'
import {
  orderSourceEnum,
  platformOrderTypeEnum,
  preferDeliverFlagEnum,
  productSettlementStatus,
  settlementStatus2,
  settlementStatus3
} from './data'

import { channelEnum, productStatsEnum2c, productStatsEnum2b, productDeliveryStatus } from '../data'
import { clearForm, setDefaultForm } from '@/util/common'
import { ShopType } from '@/common/const'
import { isTkWhiteUserApi } from '@/apis/api'
import { request } from '@/config/request/interceptors'


export default /*#__PURE__*/_defineComponent({
  props: ['form', 'states', 'isShopify', 'isTiktok', 'isWhiteUser'],
  emits: ['update:form', 'resetForm'],
  setup(__props, { expose, emit: emits }) {

const props = __props



const defaultForm = {
  platformOrderNoList: [],
  customerOrderNo: '',
  orderSource: '',
  platformOrderType: '',
  preferDeliverFlag: '',
  createStartTime: '',
  createEndTime: '',
  deliverTimeStart: '',
  deliverTimeEnd: '',
  deliveryCountry: '',
  wareHouseLocation: '',
  overSeasStockOrderFlag: '',
  apiOrderMergeFlag: '',
  reservedSaleFlag: ''
}

const customerShopPlatform = store.getters?.shopInfo?.customerShopPlatform

const getForm = (form: any) => setDefaultForm(cloneDeep(toRaw(form)), defaultForm)

const _form = ref(getForm(props.form))
const isDate = ref('orderDate')
const linkForm = ref({
  productSku: '',
  productTitleJp: '',
  channel: '',
  reachDelay: '',
  orderItemStatus: '',
  customerProductMskuList: '',
  settleStatus: '',
  goodsCountry: '',
  deliveryStatus: '',
  purchaseCountry: ''
})
const isPreSaleWhiteList = computed(() => store.getters.isPreSaleWhiteList)
watch(() => props.form, (newValue) => {
  _form.value = getForm(newValue)
})
const searchDate = computed({
  get: () =>
    isDate.value === 'orderDate'
      ? [_form.value.createStartTime, _form.value.createEndTime]
      : [_form.value.deliverTimeStart, _form.value.deliverTimeEnd],
  set: (newVal) => {
    isDate.value === 'orderDate'
      ? [_form.value.createStartTime, _form.value.createEndTime] = newVal ?? []
      : [_form.value.deliverTimeStart, _form.value.deliverTimeEnd] = newVal ?? []
  }
})

const clearDate = () => {
  _form.value.createStartTime = ''
  _form.value.createEndTime = ''
  _form.value.deliverTimeStart = ''
  _form.value.deliverTimeEnd = ''
}

watch(() => isDate.value, clearDate)

const isMergeOrderWhiteShop = ref(false)

onMounted(async () => {
  request.customer.customer.shopIsMergeOrderWhiteShop({
    customerShopId: store.getters.curShop
  }).then((res) => {
    isMergeOrderWhiteShop.value = res.data!
  })
})
/** change优先发货选项时 */
const changePreferDeliverFlag = (val: string) => {
  //   监听，则直接请求列表
  //   if (val === '1') {
  submit()
  //   }
}

const submit = () => {
  emits('update:form', cloneDeep(toRaw(_form.value)))
}

const resetForm = () => {
  clearForm(_form.value)
  clearForm(linkForm.value)
  emits('update:form', cloneDeep(toRaw(_form.value)))
  emits('resetForm')
}

const DateEnum = {
  orderDate: t('下单日'),
  shippingDate: t('发货日')
}

const setFormSearch = (form) => {
  clearForm(_form.value)
  clearForm(linkForm.value)
  _form.value = form
  emits('update:form', cloneDeep(toRaw(_form.value)))
}

expose({
  setFormSearch
})


return (_ctx: any,_cache: any) => {
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_icon = _resolveComponent("el-icon")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("p", _hoisted_2, _toDisplayString(_unref(t)('订单搜索')), 1),
      _createVNode(_component_el_form, {
        inline: true,
        model: _form.value
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_form_item, {
            label: _unref(t)('THE CKB订单编号'),
            prop: "platformOrderNoList"
          }, {
            default: _withCtx(() => [
              _createVNode(NewInputBatchSearch, {
                modelValue: _form.value.platformOrderNoList,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_form.value.platformOrderNoList) = $event)),
                onDblclick: _cache[1] || (_cache[1] = ($event: any) => (_unref(dblclick)('platformOrderNoList'))),
                placeholder: _unref(t)('双击批量搜索'),
                style: {"width":"230px!important"},
                class: "order-item-input"
              }, null, 8, ["modelValue", "placeholder"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_form_item, {
            label: _unref(isD2C)() ? _unref(t)('客户订单编号') : _unref(t)('订单标题'),
            prop: "customerOrderNo"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: _form.value.customerOrderNo,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_form.value.customerOrderNo) = $event)),
                onDblclick: _cache[3] || (_cache[3] = ($event: any) => {_form.value.customerOrderNo = ''; _unref(dblclick)('customerOrderNoList')}),
                placeholder: _unref(t)('双击批量搜索'),
                style: {"width":"230px"}
              }, null, 8, ["modelValue", "placeholder"])
            ]),
            _: 1
          }, 8, ["label"]),
          (_unref(isD2C)() && __props.isShopify)
            ? (_openBlock(), _createBlock(_component_el_form_item, {
                key: 0,
                label: _unref(isD2C)() ? _unref(t)('订单') + `(${_unref(getCustomerShopPlatform)()})` : _unref(t)('订单'),
                prop: "orderName"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _form.value.orderName,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_form.value.orderName) = $event)),
                    onDblclick: _cache[5] || (_cache[5] = ($event: any) => {_form.value.orderName = ''; _unref(dblclick)('orderNameList')}),
                    placeholder: _unref(t)('双击批量搜索'),
                    style: {"width":"230px"}
                  }, null, 8, ["modelValue", "placeholder"])
                ]),
                _: 1
              }, 8, ["label"]))
            : _createCommentVNode("", true),
          (_unref(isD2C)())
            ? (_openBlock(), _createBlock(_component_el_form_item, {
                key: 1,
                label: _unref(t)('收件人'),
                prop: "receiveName"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _form.value.receiveName,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_form.value.receiveName) = $event)),
                    style: {"width":"230px"}
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }, 8, ["label"]))
            : _createCommentVNode("", true),
          (_unref(isD2C)())
            ? (_openBlock(), _createBlock(_component_el_form_item, {
                key: 2,
                label: _unref(t)('订单来源'),
                prop: "orderSource"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_select, {
                    modelValue: _form.value.orderSource,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_form.value.orderSource) = $event))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_option, {
                        label: _unref(t)('全部'),
                        value: ""
                      }, null, 8, ["label"]),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(orderSourceEnum), (label, value) => {
                        return _withDirectives((_openBlock(), _createBlock(_component_el_option, {
                          key: value,
                          label: label,
                          value: value
                        }, null, 8, ["label", "value"])), [
                          [_vShow, [1, 6].includes(Number(value))]
                        ])
                      }), 128)),
                      (_unref(customerShopPlatform) === _unref(ShopType).TIKTOK)
                        ? (_openBlock(), _createBlock(_component_el_option, {
                            key: 0,
                            label: "TikTok",
                            value: _unref(ShopType).TIKTOK
                          }, null, 8, ["value"]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }, 8, ["label"]))
            : _createCommentVNode("", true),
          _createVNode(_component_el_form_item, {
            label: _unref(t)('订单类型'),
            prop: "platformOrderType"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_select, {
                modelValue: _form.value.platformOrderType,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_form.value.platformOrderType) = $event))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_option, {
                    label: _unref(t)('全部'),
                    value: ""
                  }, null, 8, ["label"]),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(platformOrderTypeEnum), (label, value) => {
                    return (_openBlock(), _createElementBlock(_Fragment, { key: value }, [
                      (!(!_unref(isD2C)() && String(value) === '1'))
                        ? (_openBlock(), _createBlock(_component_el_option, {
                            key: 0,
                            label: label,
                            value: value
                          }, null, 8, ["label", "value"]))
                        : _createCommentVNode("", true)
                    ], 64))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }, 8, ["label"]),
          (_unref(isD2C)()&&_unref(isJA)())
            ? (_openBlock(), _createBlock(_component_el_form_item, {
                key: 3,
                label: _unref(t)('是否海外备货'),
                prop: "platformOrderType"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_select, {
                    modelValue: _form.value.overSeasStockOrderFlag,
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_form.value.overSeasStockOrderFlag) = $event))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_option, {
                        label: _unref(t)('全部'),
                        value: ""
                      }, null, 8, ["label"]),
                      _createVNode(_component_el_option, {
                        label: _unref(t)('是1'),
                        value: "1"
                      }, null, 8, ["label"]),
                      _createVNode(_component_el_option, {
                        label: _unref(t)('否1'),
                        value: "0"
                      }, null, 8, ["label"])
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }, 8, ["label"]))
            : _createCommentVNode("", true),
          (_unref(isD2C)())
            ? _withDirectives((_openBlock(), _createBlock(_component_el_form_item, {
                key: 4,
                label: _unref(t)('优先发货'),
                prop: "preferDeliverFlag"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_select, {
                    modelValue: _form.value.preferDeliverFlag,
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_form.value.preferDeliverFlag) = $event)),
                    onChange: changePreferDeliverFlag
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_option, {
                        label: _unref(t)('全部'),
                        value: ""
                      }, null, 8, ["label"]),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(preferDeliverFlagEnum), (label, value) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: value,
                          label: label,
                          value: value
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }, 8, ["label"])), [
                [_vShow, __props.states != 3]
              ])
            : _createCommentVNode("", true),
          (_unref(isD2C)() && isMergeOrderWhiteShop.value)
            ? (_openBlock(), _createBlock(_component_el_form_item, {
                key: 5,
                label: _unref(t)('同捆注文'),
                prop: "apiOrderMergeFlag"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_select, {
                    modelValue: _form.value.apiOrderMergeFlag,
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_form.value.apiOrderMergeFlag) = $event))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_option, {
                        label: _unref(t)('全部'),
                        value: ""
                      }, null, 8, ["label"]),
                      _createVNode(_component_el_option, {
                        label: _unref(t)('是1'),
                        value: "1"
                      }, null, 8, ["label"])
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }, 8, ["label"]))
            : _createCommentVNode("", true),
          _createVNode(_component_el_form_item, {
            label: _unref(t)('订单是否结算'),
            prop: "preferDeliverFlag"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_select, {
                modelValue: _form.value.platformOrderSettleStatus,
                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_form.value.platformOrderSettleStatus) = $event))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_option, {
                    label: _unref(t)('全部'),
                    value: ""
                  }, null, 8, ["label"]),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(settlementStatus3), (label, value) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: value,
                      label: label,
                      value: value
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_form_item, {
            label: _unref(t)('采购国家'),
            prop: "purchaseCountry"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_select, {
                modelValue: _form.value.purchaseCountry,
                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_form.value.purchaseCountry) = $event))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_option, {
                    label: _unref(t)('全部'),
                    value: ""
                  }, null, 8, ["label"]),
                  _createVNode(_component_el_option, {
                    label: _unref(t)('中国'),
                    value: "CN"
                  }, null, 8, ["label"]),
                  _createVNode(_component_el_option, {
                    label: _unref(t)('日本'),
                    value: "JP"
                  }, null, 8, ["label"])
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }, 8, ["label"]),
          (_unref(isD2C)())
            ? (_openBlock(), _createBlock(_component_el_form_item, {
                key: 6,
                label: _unref(t)('发货仓库'),
                prop: "wareHouseLocation"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_select, {
                    modelValue: _form.value.wareHouseLocation,
                    "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_form.value.wareHouseLocation) = $event))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_option, {
                        label: _unref(t)('全部'),
                        value: ""
                      }, null, 8, ["label"]),
                      _createVNode(_component_el_option, {
                        label: _unref(t)('中国'),
                        value: "CN"
                      }, null, 8, ["label"]),
                      _createVNode(_component_el_option, {
                        label: _unref(t)('日本'),
                        value: "JP"
                      }, null, 8, ["label"])
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }, 8, ["label"]))
            : _createCommentVNode("", true),
          (_unref(isD2C)())
            ? (_openBlock(), _createBlock(_component_el_form_item, { key: 7 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_select, {
                    modelValue: isDate.value,
                    "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((isDate).value = $event)),
                    style: {"margin-right":"20px"}
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(DateEnum, (label, value) => {
                        return _createVNode(_component_el_option, {
                          key: value,
                          label: label,
                          value: value
                        }, null, 8, ["label", "value"])
                      }), 64))
                    ]),
                    _: 1
                  }, 8, ["modelValue"]),
                  _createVNode(_component_el_date_picker, {
                    modelValue: _unref(searchDate),
                    "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (_isRef(searchDate) ? (searchDate).value = $event : null)),
                    type: "daterange",
                    "range-separator": "-",
                    "start-placeholder": _unref(t)('开始时间'),
                    "end-placeholder": _unref(t)('结束时间'),
                    format: "YYYY-MM-DD",
                    "value-format": "YYYY-MM-DD"
                  }, null, 8, ["modelValue", "start-placeholder", "end-placeholder"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_unref(isD2C)())
            ? (_openBlock(), _createBlock(_component_el_form_item, {
                key: 8,
                label: _unref(t)('是否拦截'),
                prop: "interceptFlag"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_select, {
                    modelValue: _form.value.interceptFlag,
                    "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_form.value.interceptFlag) = $event))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_option, {
                        label: _unref(t)('全部'),
                        value: ""
                      }, null, 8, ["label"]),
                      _createVNode(_component_el_option, {
                        label: _unref(t)('保留中'),
                        value: 1
                      }, null, 8, ["label"]),
                      _createVNode(_component_el_option, {
                        label: _unref(t)('通常出荷'),
                        value: 2
                      }, null, 8, ["label"])
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }, 8, ["label"]))
            : _createCommentVNode("", true),
          (_unref(isD2C)())
            ? (_openBlock(), _createBlock(_component_el_form_item, {
                key: 9,
                label: _unref(t)('是否发货'),
                prop: "platformOrderNo"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_select, {
                    modelValue: _form.value.deliverFlag,
                    "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_form.value.deliverFlag) = $event))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_option, {
                        label: _unref(t)('全部'),
                        value: ""
                      }, null, 8, ["label"]),
                      _createVNode(_component_el_option, {
                        label: _unref(t)('已发货2'),
                        value: 1
                      }, null, 8, ["label"]),
                      _createVNode(_component_el_option, {
                        label: _unref(t)('未发货2'),
                        value: 0
                      }, null, 8, ["label"])
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }, 8, ["label"]))
            : _createCommentVNode("", true),
          _createVNode(_component_el_form_item, {
            label: _unref(t)('待处理异常'),
            prop: "waitDealAbnormal"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_select, {
                modelValue: _form.value.waitDealAbnormal,
                "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_form.value.waitDealAbnormal) = $event))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_option, {
                    label: _unref(t)('有1'),
                    value: 1
                  }, null, 8, ["label"]),
                  _createVNode(_component_el_option, {
                    label: _unref(t)('无1'),
                    value: 0
                  }, null, 8, ["label"])
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }, 8, ["label"]),
          (__props.isWhiteUser)
            ? (_openBlock(), _createBlock(_component_el_form_item, {
                key: 10,
                label: "Tiktok注文",
                prop: "platformOrderType"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_select, {
                    modelValue: _form.value.tiktokOrderFlag,
                    "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_form.value.tiktokOrderFlag) = $event))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_option, {
                        label: _unref(t)('全部'),
                        value: ""
                      }, null, 8, ["label"]),
                      _createVNode(_component_el_option, {
                        label: _unref(t)('是1'),
                        value: 1
                      }, null, 8, ["label"])
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_unref(isPreSaleWhiteList))
            ? (_openBlock(), _createBlock(_component_el_form_item, {
                key: 11,
                label: _unref(t)('予約販売'),
                class: "fx-1"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_select, {
                    modelValue: _form.value.reservedSaleFlag,
                    "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_form.value.reservedSaleFlag) = $event)),
                    placeholder: _unref(t)('请选择')
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_option, {
                        label: _unref(t)('全部'),
                        value: ""
                      }, null, 8, ["label"]),
                      _createVNode(_component_el_option, {
                        label: _unref(t)('是1'),
                        value: 1
                      }, null, 8, ["label"])
                    ]),
                    _: 1
                  }, 8, ["modelValue", "placeholder"])
                ]),
                _: 1
              }, 8, ["label"]))
            : _createCommentVNode("", true),
          _createVNode(_component_el_form_item, null, {
            default: _withCtx(() => [
              _createVNode(_component_el_button, {
                type: "primary",
                onClick: submit
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('搜索')), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_button, { onClick: resetForm }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('重置')), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("p", _hoisted_4, _toDisplayString(_unref(t)('商品搜索')), 1),
      _createVNode(_component_el_form, {
        inline: true,
        model: linkForm.value
      }, {
        default: _withCtx(() => [
          _withDirectives(_createVNode(_component_el_form_item, {
            label: _unref(t)('商品采购状态')
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_select, {
                modelValue: linkForm.value.orderItemStatus,
                "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((linkForm.value.orderItemStatus) = $event)),
                onChange: _cache[23] || (_cache[23] = ($event: any) => (_ctx.$router.push(_unref(useRtfix)('OrderSearch', { query: { orderItemStatus: linkForm.value.orderItemStatus } }))))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_option, {
                    label: _unref(t)('全部'),
                    value: ""
                  }, null, 8, ["label"]),
                  (_unref(isD2C)())
                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_unref(productStatsEnum2c), (label, value) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: value,
                          label: label,
                          value: value
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    : _createCommentVNode("", true),
                  (!_unref(isD2C)())
                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_unref(productStatsEnum2b), (label, value) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: value,
                          label: label,
                          value: value
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }, 8, ["label"]), [
            [_vShow, __props.states != 3]
          ]),
          _withDirectives(_createVNode(_component_el_form_item, {
            label: _unref(t)('商品发货状态')
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_select, {
                modelValue: linkForm.value.deliveryStatus,
                "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((linkForm.value.deliveryStatus) = $event)),
                onChange: _cache[25] || (_cache[25] = ($event: any) => (_ctx.$router.push(_unref(useRtfix)('OrderSearch', { query: { deliveryStatus: linkForm.value.deliveryStatus } }))))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_option, {
                    label: _unref(t)('全部'),
                    value: ""
                  }, null, 8, ["label"]),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(productDeliveryStatus), (item) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: item.value,
                      label: item.label,
                      value: item.value
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }, 8, ["label"]), [
            [_vShow, __props.states != 3]
          ]),
          _createVNode(_component_el_form_item, {
            label: _unref(t)('客户商品sku')
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: linkForm.value.customerProductMskuList,
                "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((linkForm.value.customerProductMskuList) = $event)),
                onDblclick: _cache[28] || (_cache[28] = ($event: any) => {linkForm.value.customerProductMskuList = ''; _unref(dblclick)('customerProductMskuList')}),
                placeholder: _unref(t)('双击批量搜索'),
                style: {"width":"240px"},
                maxlength: "100"
              }, {
                suffix: _withCtx(() => [
                  _createVNode(_component_el_icon, {
                    class: "el-input__icon",
                    style: {"cursor":"pointer"},
                    onClick: _cache[26] || (_cache[26] = ($event: any) => (_ctx.$router.push(_unref(useRtfix)('OrderSearch', { query: { customerProductMskuList: linkForm.value.customerProductMskuList } }))))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(Search))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["modelValue", "placeholder"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_form_item, {
            label: _unref(t)('平台商品SKU')
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: linkForm.value.productSku,
                "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((linkForm.value.productSku) = $event)),
                onDblclick: _cache[31] || (_cache[31] = ($event: any) => {linkForm.value.productSku = ''; _unref(dblclick)('productSkuList')}),
                placeholder: _unref(t)('双击批量搜索'),
                style: {"width":"240px"}
              }, {
                suffix: _withCtx(() => [
                  _createVNode(_component_el_icon, {
                    class: "el-input__icon",
                    style: {"cursor":"pointer"},
                    onClick: _cache[29] || (_cache[29] = ($event: any) => (_ctx.$router.push(_unref(useRtfix)('OrderSearch', { query: { productSku: linkForm.value.productSku } }))))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(Search))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["modelValue", "placeholder"])
            ]),
            _: 1
          }, 8, ["label"]),
          (_unref(isD2C)())
            ? (_openBlock(), _createBlock(_component_el_form_item, {
                key: 0,
                label: _unref(t)('商品名称')
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: linkForm.value.productTitleJp,
                    "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((linkForm.value.productTitleJp) = $event))
                  }, {
                    suffix: _withCtx(() => [
                      _createVNode(_component_el_icon, {
                        class: "el-input__icon",
                        style: {"cursor":"pointer"},
                        onClick: _cache[32] || (_cache[32] = ($event: any) => (_ctx.$router.push(_unref(useRtfix)('OrderSearch', { query: { productTitleJp: linkForm.value.productTitleJp } }))))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(Search))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }, 8, ["label"]))
            : _createCommentVNode("", true),
          _createVNode(_component_el_form_item, {
            label: _unref(t)('业务类型')
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_select, {
                modelValue: linkForm.value.channel,
                "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((linkForm.value.channel) = $event)),
                onChange: _cache[35] || (_cache[35] = ($event: any) => (_ctx.$router.push(_unref(useRtfix)('OrderSearch', { query: { channel: linkForm.value.channel } }))))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_option, {
                    label: _unref(t)('全部'),
                    value: ""
                  }, null, 8, ["label"]),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(channelEnum), (label, value) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: value,
                      label: label,
                      value: value
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_form_item, {
            label: _unref(t)('到货延迟')
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_select, {
                modelValue: linkForm.value.reachDelay,
                "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => ((linkForm.value.reachDelay) = $event)),
                onChange: _cache[37] || (_cache[37] = ($event: any) => (_ctx.$router.push(_unref(useRtfix)('OrderSearch', { query: { reachDelay: linkForm.value.reachDelay } }))))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_option, {
                    label: _unref(t)('是1'),
                    value: 1
                  }, null, 8, ["label"]),
                  _createVNode(_component_el_option, {
                    label: _unref(t)('否1'),
                    value: 0
                  }, null, 8, ["label"])
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_form_item, {
            label: _unref(t)('采购国家'),
            prop: "purchaseCountry"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_select, {
                modelValue: linkForm.value.purchaseCountry,
                "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => ((linkForm.value.purchaseCountry) = $event)),
                onChange: _cache[39] || (_cache[39] = ($event: any) => (_ctx.$router.push(_unref(useRtfix)('OrderSearch', { query: { purchaseCountry: String(linkForm.value.purchaseCountry) } }))))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_option, {
                    label: _unref(t)('全部'),
                    value: ""
                  }, null, 8, ["label"]),
                  _createVNode(_component_el_option, {
                    label: _unref(t)('中国'),
                    value: "CN"
                  }, null, 8, ["label"]),
                  _createVNode(_component_el_option, {
                    label: _unref(t)('日本'),
                    value: "JP"
                  }, null, 8, ["label"])
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_form_item, {
            label: _unref(t)('订单是否结算'),
            prop: "preferDeliverFlag"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_select, {
                modelValue: linkForm.value.settleStatus,
                "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event: any) => ((linkForm.value.settleStatus) = $event)),
                onChange: _cache[41] || (_cache[41] = ($event: any) => (_ctx.$router.push(_unref(useRtfix)('OrderSearch', { query: { settleStatus: String(linkForm.value.settleStatus) } }))))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_option, {
                    label: _unref(t)('全部'),
                    value: ""
                  }, null, 8, ["label"]),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(productSettlementStatus), (label, value) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: value,
                      label: label,
                      value: value
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }, 8, ["label"])
        ]),
        _: 1
      }, 8, ["model"])
    ])
  ]))
}
}

})